import React from 'react'
import Root from 'App/Root'
import Pages from './Pages'
import {Router, Route, browserHistory} from 'react-router'
import ReactPixel from 'react-facebook-pixel'

export default class App extends React.Component {
  componentDidMount() {
    ReactPixel.init('426049021986026')
    ReactPixel.pageView() // For tracking page view
  }
  render() {
    return (
      <Router history={browserHistory}>
        <Route component={Root}>{Pages}</Route>
      </Router>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/index.js